export const ERROR_STATE = {
  RECOMMENDATION: 'recommendation',
  SERVICES: 'services',
} as const;

export const FREQUENCY = [
  'weekly',
  'bi-weekly',
  'monthly',
  '6 month authorization period',
] as const;
